module.exports = __webpack_public_path__ + "img/gd.f618d2eb.svg";